import { cva, VariantProps } from 'class-variance-authority';

export const input = cva(
  ['peer', 'focus:ring-0', 'outline-0', 'text-base', 'font-medium'],
  {
    variants: {
      intent: {
        text: ['px-0', 'block', 'w-full', 'pb-2'],
        checkbox: ['rounded-sm', 'before:rounded-sm'],
        radio: ['rounded-full', 'before:rounded-full'],
      },
      disabled: {
        true: ['text-neutral-500', 'bg-transparent', 'border-neutral-400'],
        false: ['text-inherit', 'border-neutral-700'],
      },
    },
    compoundVariants: [
      {
        intent: ['checkbox', 'radio'],
        className: [
          'grid',
          'place-content-center',
          'mr-4',
          'pr-4',
          'w-6',
          'h-6',
          'inline-flex',
          'items-center',
          'justify-center',
          'border',
          'appearance-none',
          'before:block',
          "before:content-['']",
          'before:w-4',
          'before:h-4',
          'before:ml-4',
          'before:scale-0',
          'before:ease-in-out',
          'before:duration-100',
          'before:shadow-[inset_16px_16px_var(--osb-primary-800)]',
          'checked:before:scale-100',
          'disabled:before:shadow-[inset_16px_16px_var(--osb-neutral-400)]',
        ],
      },
    ],
  }
);

export const inputWrapper = cva(['peer', 'flex-1'], {
  variants: {
    intent: {
      text: ['pt-5', 'relative'],
      checkbox: ['inline-flex', 'flex-row', 'items-center'],
      radio: ['inline-flex', 'flex-row', 'items-center'],
    },
  },
});

export const label = cva(['w-full']);

export const adornment = cva([], {
  variants: {
    position: {
      left: ['pr-3'],
      right: ['mr-0', 'ml-auto', 'pl-3'],
    },
    pb: {
      true: ['pb-2'],
      false: [],
    },
  },
});

export const group = cva(
  ['group', 'relative', 'flex-row', 'text-inherit', 'items-end'],
  {
    variants: {
      intent: {
        text: [
          'flex',
          'border-0',
          'border-b-[1px]',
          'sm:top-[4px]',
          'pb-[1px]',
        ],
        checkbox: ['inline-flex'],
        radio: ['inline-flex'],
      },
      disabled: {
        true: [
          'border-neutral-400',
          'focus-within:border-neutral-400',
          'focus-within:border-b',
          'group-hover:border-neutral-400',
          'group-hover:border-b',
        ],
        false: [],
      },

      row: {
        true: ['flex', 'flex-row', 'items-center'],
        false: [],
      },
      ring: {
        true: [
          'p-2',
          'hover:ring',
          'focus-within:ring',
          'ring-primary-600',
          'rounded-lg',
        ],
        false: [],
      },
      error: {
        true: ['border-red-400'],
        false: [],
      },
    },
    compoundVariants: [
      {
        intent: 'text',
        disabled: false,
        error: false,
        className: [
          'border-neutral-700',
          'focus-witin:border-primary-600',
          'hover:border-primary-600',
        ],
      },
      {
        intent: 'text',
        disabled: false,
        className: [
          'focus-within:border-b-[2px]',
          'hover:border-b-[2px]',
          'hover:pb-0',
          'focus:pb-0',
        ],
      },
      {
        ring: true,
        disabled: true,
        className: ['hover:ring-0', 'focus-within:ring-0'],
      },
    ],
  }
);

export type StyleProps = VariantProps<typeof input>;
